import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Copy, MessageSquare } from "lucide-react";
import clsx from "clsx";
import { toast } from "sonner";

export const gatewayBase = () => `${process.env.REACT_APP_BACKEND_URL}/api/v1`;
export const curlFor = (model, key = "$COREX_API_KEY") => `curl ${gatewayBase()}/chat/completions \\\n  -H "Authorization: Bearer ${key}" \\\n  -H "Content-Type: application/json" \\\n  -d '{"model":"${model}","messages":[{"role":"user","content":"Hello"}]}'`;

/** Copy button with "Copied ✓" feedback. Used everywhere something is copied. */
export function CopyBtn({ text, label, size = "sm", variant = "primary", className, testid, icon: I = Copy }) {
  const [ok, setOk] = useState(false);
  const copy = async () => { try { await navigator.clipboard.writeText(text); } catch { /* clipboard blocked */ } setOk(true); toast.success("Copied ✓", { duration: 1500 }); setTimeout(() => setOk(false), 1500); };
  return (<button type="button" onClick={copy} className={clsx("cx-btn", `cx-btn-${variant}`, size === "sm" && "cx-btn-sm", className)} data-testid={testid} data-copied={ok}>
    {ok ? <Check size={13} /> : <I size={13} />} {ok ? "Copied ✓" : label}
  </button>);
}

/** The prominent connection strip: Copy base URL · Copy model name · Copy curl · Try in Playground. */
export function CopyBar({ endpoint, compact = false, className }) {
  const nav = useNavigate();
  return (<div className={clsx("flex flex-wrap gap-2", className)} data-testid={`copy-bar-${endpoint.id}`}>
    <CopyBtn text={gatewayBase()} label={compact ? "Base URL" : "Copy base URL"} testid={`copy-base-url-${endpoint.id}`} />
    <CopyBtn text={endpoint.slug} label={compact ? "Model name" : "Copy model name"} testid={`copy-model-${endpoint.id}`} />
    <CopyBtn text={curlFor(endpoint.slug)} label={compact ? "curl" : "Copy curl example"} testid={`copy-curl-${endpoint.id}`} />
    <button type="button" className="cx-btn cx-btn-secondary cx-btn-sm" onClick={() => nav(`/playground?endpoint=${endpoint.id}`)} data-testid={`try-playground-${endpoint.id}`}><MessageSquare size={13} /> Try in Playground</button>
  </div>);
}
